'use strict'

import angular from 'angular'
import './errorsHandler.service'

angular.module('errorsHandler', ['errorsHandler.services'])